import { ChevronRightIcon } from "@primer/octicons-react";
import { ActionList, Box, Label, Octicon } from '@primer/react';
import { useSelector } from 'react-redux';
import FileType from "../../../components/files/FileType";
import Text from '../../../components/ui/text';
import { RootState } from '../../../state/reducers';
import { useLanguage } from "../../../hooks/useLanguage";
interface ILegalGroupListProps {
    lan?: string
}
const LegalGroupList = (props: ILegalGroupListProps) => {
    const { groups } = useSelector((x: RootState) => x.legalDocument.group)
    const { documents } = useSelector((x: RootState) => x.legalDocument.documents)
    const { language } = useLanguage();
    const isEnglish = props.lan === "en" || language === "en" ? true : false;
    console.log({
        groups,
        documents,
        isEnglish,
        lan: props.lan
    });
    return (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
            {groups.filter(g => g.is_active).map(group => {
                const files = documents.filter(x => x.is_active).filter(x => x.sis_legal_group_id === group.id)
                return (
                    <Box sx={{ mb: 3 }}>
                        <Box sx={{
                            borderBottom: "1px solid",
                            borderBottomColor: "border.default",
                            mb: 2,
                            pb: 2,
                            display: "flex"
                        }}>
                            <Box sx={{ flex: 1 }}>
                                <Text text={isEnglish ? group.name_en : group.name} sx={{
                                    fontSize: 16,
                                    fontWeight: 600
                                }} />
                            </Box>
                            <Box>
                                <Label>Total: {files.length} file(s) </Label>
                            </Box>
                        </Box>
                        <ActionList variant='full'>
                            {files.map(file => {
                                return (
                                    <ActionList.LinkItem href={file.url}
                                    //  target='_blank'
                                    >
                                        <ActionList.LeadingVisual>
                                            <FileType file_name={file.url}
                                                sx={{
                                                    height: "24px",
                                                    mt: 1,
                                                    mr: 2,
                                                    pl: 2
                                                }}
                                            />
                                        </ActionList.LeadingVisual>
                                        <Box>{isEnglish ? file.name_en : file.name}</Box>
                                        <ActionList.Description variant='block'>
                                            <Box sx={{ whiteSpace: "pre-wrap" }}>
                                                {file.description}
                                            </Box>
                                        </ActionList.Description>
                                        <ActionList.TrailingVisual>
                                            <Octicon icon={ChevronRightIcon}
                                            />
                                        </ActionList.TrailingVisual>
                                    </ActionList.LinkItem>
                                );
                            })}
                        </ActionList>
                    </Box>
                );
            })}
        </Box>
    );
};

export default LegalGroupList;